import { useSubscriptionExpired } from "src/hooks/use-subscription-expired";
import User01Icon from "@untitled-ui/icons-react/build/esm/User01";
import { Avatar, Box, Button, ButtonBase, SvgIcon } from "@mui/material";
import { useAuth } from "src/hooks/use-auth";
import { useMobile } from "src/hooks/use-mobile";
import { usePopover } from "src/hooks/use-popover";
import { AccountPopover } from "./account-popover";
import { useRouter } from "src/hooks/use-router";
import { paths } from "src/paths";
import { CommonLabel } from "src/components/common-label";
import { AccountButtonLayout } from "./account-button-layout";

export const AccountButton = () => {
  const router = useRouter();
  const { user } = useAuth();
  const subscriptionExpired = useSubscriptionExpired(user);
  const isMobile = useMobile();
  const popover = usePopover();
  console.log("user: %O", user);

  return (
    <>
      <AccountButtonLayout>
        {!user && (
          <Button
            sx={{ height: 25, width: 50, flexShrink: 0 }}
            variant="contained"
            onClick={() => router.push(paths.auth.jwt.login)}
          >
            로그인
          </Button>
        )}

        {user && subscriptionExpired && (
          <Button
            sx={{ height: 25, width: 50, flexShrink: 0 }}
            variant="contained"
            onClick={() => router.push(paths.dashboard.pricing.index)}
          >
            사용신청
          </Button>
        )}
        {user && !isMobile && (
          <CommonLabel
            label={user.name}
            sx={{
              minWidth: 0,
              maxWidth: { xs: 56, sm: 96, lg: 160 },
              flexShrink: 1,
            }}
          />
        )}
        {user && (
          <Box
            component={ButtonBase}
            onClick={popover.handleOpen}
            ref={popover.anchorRef}
            sx={{
              alignItems: "center",
              display: "flex",
              borderWidth: 2,
              borderStyle: "solid",
              borderColor: "divider",
              height: 30,
              width: 30,
              flexShrink: 0,
              borderRadius: "50%",
            }}
          >
            <Avatar
              sx={{
                height: 25,
                width: 25,
              }}
              src={user ? user.avatar : null}
            >
              <SvgIcon>
                <User01Icon />
              </SvgIcon>
            </Avatar>
          </Box>
        )}
      </AccountButtonLayout>
      <AccountPopover
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
      />
    </>
  );
};
